import { Route } from '@angular/router';
import { JobsComponent } from './jobs.component';

export const JobsRoutes: Route[] = [
  {
    path: 'docs',
    component: JobsComponent
  }
];
